import React from "react";
import Button from "components/UI/Button";
import { Link } from "react-router-dom";
import { urlify } from "config/constants";

class NoteView extends React.Component {
  componentDidUpdate() {
    // console.log(this.props.gym_notes, "gymnotes");
    document.getElementById("note_text").innerHTML = urlify(
      this.props.gym_note ? this.props.gym_note : "Fetching Notes...."
    );
  }
  render() {
    const { gym_id } = this.props;
    console.log(gym_id);

    // console.log(urlify(props.gym_note));
    return (
      <div style={style.wrapper}>
        <p style={style.p} id="note_text">
          {this.props.gym_note}
        </p>
        <Link to="/gyms/gym/notes/edit">
          <Button style={style.button} holo>
            Edit
          </Button>
        </Link>
      </div>
    );
  }
}

export default NoteView;
const style = {
  wrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    marginTop: "10px",
    alignItems: "center"
  },
  button: {
    width: "150px",
    height: "61px",
    fontSize: "16px"
  },
  p: {
    margin: "25px",
    padding: "25px",
    height: "300px",
    width: "80%",
    border: "2px solid #c6c6c6",
    borderRadius: "40px",
    fontSize: "16px",
    textAlign: "left",
    whiteSpace: "pre-wrap"
  }
};
